import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { LoadIdView } from '../../../../models/shipment-id-view.model';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { ShipmentLoadStatusChainModel } from '../../models/shipment-load-status-chain.model';
import { ShipmentLoadEndpoint } from '../../constants';
import { getQueryStringFromObject } from '../../../../../common';

@Injectable({ providedIn: 'root' })
export class ShipmentLoadStatusChainService {
  constructor(private http: WrapperHttpService) {}

  getStatusChainData(loadIdView: LoadIdView): Observable<{ milestones: ShipmentLoadStatusChainModel[] }> {
    const url =
      `${API_URL}${ShipmentLoadEndpoint.Base}${ShipmentLoadEndpoint.Loads}${ShipmentLoadEndpoint.Milestones}?` +
      getQueryStringFromObject(loadIdView);

    return this.http.withLoading().get(url);
  }
}
